import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { ProgressDialog } from '@yola/ws-ui';

const defaultCaptions = {};

function TranslationGuidelinesProcessingDialog({ captions = defaultCaptions, ...restProps }) {
  const getCaptions = (captionsOverrides) => ({
    title: `${i18next.t('Updating guidelines')}...`,
    ...captionsOverrides,
  });

  return (
    <ProgressDialog
      overlay="visible"
      progressType="indeterminate"
      cancelable={false}
      captions={getCaptions(captions)}
      width={336}
      height={109}
      minHeight={109}
      {...restProps}
    />
  );
}

TranslationGuidelinesProcessingDialog.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
  }),
};

export default TranslationGuidelinesProcessingDialog;
